import OurServices from "./OurServices";
import WhyChooseUs from "./WhyChooseUs";
import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import Loader from "../../components/other/Loader";
import HeroSection from "../../layout/HeroSection";
import HelpSection from "../../components/HelpSection";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboard, fetchServices } from "../../redux/action/homeAction";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { homeData, isLoading } = useSelector((state) => state?.homeReducer);

  useEffect(() => {
    dispatch(fetchDashboard());
    dispatch(fetchServices());
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  const openLinksInNewTab = (html) => {
    if (!html) return "";

    return html.replace(
      /<a /g,
      '<a target="_blank" rel="noopener noreferrer" '
    );
  };
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1>{homeData?.banner_title}</h1>}
        banner_image={homeData?.banner_image}
        subtitle={homeData?.banner_sub_title}
        banner_text={homeData?.banner_text}
      />
      {homeData?.banner_text && (
        <section style={{ background: "rgb(215 140 46 / 9%" }}>
          <div className="container py-5 ">
            <div className="row">
              <div className="col-md-12">
                <div
                  dangerouslySetInnerHTML={{ __html: openLinksInNewTab(homeData?.banner_text) }}
                />
              </div>
            </div>
          </div>
        </section>
      )}
      <HelpSection
        videoUrl={homeData?.link}
        thumbnailUrl={homeData?.youtube_image}
        media_content={homeData?.media_content}
      />
      <OurServices />
      <WhyChooseUs />
      <Footer />
    </div>
  );
};

export default Dashboard;
